// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .filter-label {\r\n  margin-top: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
